import React, { useState } from 'react';
import moment from 'moment-timezone';
import { DefaultSwitch } from 'services/UIUtils';
import DefaultButton from 'components/Utils/NewDefaultButton';
import DefaultDatePicker from 'components/Utils/DefaultDatePicker';
import ProgressMessage from 'components/Utils/ProgressMessage';
import Icon from 'components/Utils/NewIcon';
import StaffTimePicker from 'components/Utils/StaffTimePicker';
import DefaultModal from 'components/Utils/DefaultModal';
import { NoteCommands } from 'components/Test/MonacoTest';
import MobileExpand from '../../../../Common/MobileExpand';

const AppointmentNoteTopBar = ({
  onClose,
  onClear,
  onStartNewNote,
  date,
  onChange,
  physician,
  savingDraft,
  canSaveDraft,
  onSave,
  loading,
  saveButtonRef,
  selectNote,
  extraButtons,
  control,
}) => {
  const [showHelp, setShowHelp] = useState(false);

  function changeDate(newDate) {
    setDateTime(newDate, date);
  }

  function changeTime(newDate) {
    setDateTime(date, newDate);
  }

  function setDateTime(date = moment().unix(), time = moment().unix()) {
    date = moment.unix(date);
    time = moment.unix(time);
    date.hour(time.hour());
    date.minute(time.minute());
    onChange('date', date.unix());
  }

  const disabledTime = () => ({
    disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7, 19, 20, 21, 22, 23, 24],
    disabledMinutes: () => [],
    disabledSeconds: () => [],
  });

  return (
    <div className="row top-bar">
      {showHelp && (
        <DefaultModal
          className="fit-modal note-help-document-modal"
          title="Note Commands"
          wrap={true}
          content={<NoteCommands />}
          isOpen={showHelp}
          onRequestClose={() => setShowHelp(false)}
        />
      )}
      <div className="left-side flex items-center">
        <Icon src="xmark" className="close-icon" onClick={onClose} width="20px" />
        <span className="small-title delete">Encounter Note</span>
        {/*<ToggleSwitch
          className="note-version-switch"
          option1={NOTE_TEXT_MODE.v1}
          option2={NOTE_TEXT_MODE.v2}
          onChange={onChangeNoteVersion}
          toggled={noteVersion === NOTE_TEXT_MODE.v2}
        />
        {noteVersion === NOTE_TEXT_MODE.v2 && (
          <IconButton
            style={{ width: "25px", height: "25px" }}
            onClick={() => setShowHelp(true)}
          >
            <Icon src="circle-question" width="15px" />
          </IconButton>
        )}*/}
        <div className="saving-indicator">
          {!savingDraft && canSaveDraft && <span className="pending">Draft Pending</span>}
          {savingDraft && <ProgressMessage className="save-draft-loading" message="Saving Draft" />}
        </div>
      </div>
      <MobileExpand>
        {!selectNote ? (
          <div className="right-side items-center flex-wrap">
            <DefaultButton
              id="Save-Note-Close-button"
              name="Save Note"
              buttonRef={saveButtonRef}
              onClick={onSave}
              loading={loading === 'save-close'}
              className="blue"
              style={{ height: '35px', width: '100px', marginLeft: '10px' }}
            />
            {extraButtons}
            <DefaultButton
              name="Clear Draft"
              onClick={onClear}
              style={{ height: '35px', width: '105px', marginLeft: '10px' }}
              className="white"
            />
            {!physician.intern_of && (
              <div className="hide-wrapper">
                <DefaultSwitch
                  name="hide"
                  control={control}
                  className="red"
                  id="hide"
                  label="Hide"
                />
              </div>
            )}
            <div className="datetime">
              <DefaultDatePicker
                label="Date"
                name="date"
                value={date || moment().unix()}
                onChange={(event, date) => changeDate(date)}
                style={{ width: '110px' }}
                small={true}
              />
              <StaffTimePicker
                id="time-picker"
                value={date || moment().unix()}
                onChange={(event, date) => changeTime(date)}
                style={{ width: '100px' }}
                small={true}
                use12Hours={false}
                disabledTime={disabledTime}
                hideDisabledOptions={true}
              />
            </div>
          </div>
        ) : (
          <div className="right-side items-center flex-wrap">
            <DefaultButton
              name="Start New Draft"
              onClick={onStartNewNote}
              style={{ height: '35px', marginLeft: '10px' }}
              className="white"
            />
          </div>
        )}
      </MobileExpand>
    </div>
  );
};

export default React.memo(AppointmentNoteTopBar);
